export enum OrganizationStatus {
    Active,
    Expired,
    Deactivated,
}